/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { TypePolicies } from '@apollo/client';
import {
  ListScratchpadBucketsQueryVariables,
  ListScratchpadHistoriesQueryVariables,
  ListScratchpadsQueryVariables,
} from '../graphql/generated';
import { cacheMergePaginatedList } from './cache.util';

const ScratchpadCacheTypePolicies: TypePolicies = {
  Query: {
    fields: {
      listScratchpads: {
        keyArgs: ['input', ['machineId']],
        merge: (existing, incoming, { variables }) => {
          return cacheMergePaginatedList<ListScratchpadsQueryVariables>(
            existing,
            incoming,
            variables as ListScratchpadsQueryVariables
          );
        },
      },
      listScratchpadHistories: {
        keyArgs: ['input', ['scratchpadId']],
        merge: (existing, incoming, { variables }) => {
          return cacheMergePaginatedList<ListScratchpadHistoriesQueryVariables>(
            existing,
            incoming,
            variables as ListScratchpadHistoriesQueryVariables
          );
        },
      },
      listScratchpadBuckets: {
        keyArgs: [
          'input',
          ['parentId', 'scope', 'scratchpadAppSlug', 'tags', 'type'],
        ],
        merge: (existing, incoming, { variables }) => {
          return cacheMergePaginatedList<ListScratchpadBucketsQueryVariables>(
            existing,
            incoming,
            variables as ListScratchpadBucketsQueryVariables
          );
        },
      },
      getCompatibleMachinesForScratchpad: {
        keyArgs: ['input', ['scratchpadId']],
        merge: (existing, incoming) => {
          // Always return the incoming data for compatible machines
          // since the list can change based on permissions and machine state
          return incoming;
        },
      },
    },
  },
  ScratchpadPlaylist: {
    fields: {
      items: {
        merge: (_existing, incoming) => {
          return incoming;
        },
      },
    },
  },
};

export { ScratchpadCacheTypePolicies };
